import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "LoopedSquare.svg",
  "use": "LoopedSquare.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"LoopedSquare.svg\"><path d=\"M45.51,37.0209a8.5,8.5,0,1,1-8.5,8.5v-4.5h-10v4.5a8.5,8.5,0,1,1-8.5-8.5h4.5v-10h-4.5a8.5,8.5,0,1,1,8.5-8.5v4.5h10v-4.5a8.5,8.5,0,1,1,8.5,8.5h-4.5v10Zm-22.5-18.5a4.5,4.5,0,1,0-4.5,4.5h4.5Zm-4.5,22.5a4.5,4.5,0,1,0,4.5,4.5v-4.5Zm18.5-14h-10v10h10Zm8.5-4a4.5,4.5,0,1,0-4.5-4.5v4.5Zm-4.5,22.5a4.5,4.5,0,1,0,4.5-4.5h-4.5Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol